// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ordered products (redesign) — /ordered-products.
   Depends on dashboard-redesign.css for the shell tokens and the shared
   .rf-btn / .rf-segmented / .rf-num / .rf-spacer / .rf-empty. Every
   legacy column is kept; only the styling moves. */

.op-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ---------------- toolbar ---------------- */
.op-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.op-presets {
  display: flex;
  gap: 2px;
  background: #eae6dd;
  padding: 3px;
  border-radius: 9px;
}
.op-presets button {
  border: none;
  cursor: pointer;
  padding: 6px 11px;
  border-radius: 7px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: transparent;
  color: #7c766a;
  white-space: nowrap;
}
.op-presets button.is-active {
  background: #fff;
  color: #191714;
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);
}

/* range button + two-month popover (same shape as the overview picker) */
.op-cal-wrap {
  position: relative;
}
.op-range-btn {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.op-range-btn:hover,
.op-range-btn.is-open {
  border-color: #d8cfb8;
}
.op-range-days {
  font-size: 11.5px;
  font-weight: 600;
  color: #8b8477;
}
.op-caret {
  font-size: 10px;
  color: #a29b8d;
}
.op-cal {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);
  padding: 14px;
}
.op-cal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
}
.op-cal-close {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #8b8477;
}
.op-cal-months {
  display: flex;
  gap: 18px;
}
.op-cal-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0ece3;
}
.op-cal-foot span {
  flex-grow: 1;
  font-size: 12px;
  color: #8b8477;
}

.op-select {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 10px 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.op-select-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a29b8d;
}
.op-select select {
  border: none;
  outline: none;
  background: none;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  cursor: pointer;
}

.op-search {
  height: 34px;
  min-width: 190px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.op-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.op-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.op-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}

.op-btn-on {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
.op-btn-on:hover {
  background: var(--rf-brand-hover);
}

/* ---------------- KPI strip ---------------- */
.op-kpis {
  padding: 16px 28px 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  flex-shrink: 0;
}
.op-kpi {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.op-kpi-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #a29b8d;
}
.op-kpi-v {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.op-kpi-v.is-warn {
  color: #a8483e;
}
.op-kpi-v.is-ok {
  color: #4d7a52;
}
.op-kpi-sub {
  font-size: 11.5px;
  color: #8b8477;
}

/* ---------------- body: list + aside ---------------- */
.op-body {
  flex-grow: 1;
  min-height: 0;
  padding: 16px 28px 28px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 18px;
  align-items: start;
}
.op-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.op-section {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.op-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-bottom: 1px solid #e7e3da;
  background: #fdfcfa;
}
.op-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #191714;
}
.op-section.is-funeral .op-section-title::before,
.op-section.is-retail .op-section-title::before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: 1px;
}
.op-section.is-funeral .op-section-title::before {
  background: var(--rf-brand);
}
.op-section.is-retail .op-section-title::before {
  background: var(--rf-accent);
}
.op-section-meta {
  font-size: 12px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
}

/* ---------------- table ---------------- */
.op-scroll {
  overflow-x: auto;
}
.op-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.op-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #474339;
  color: #f2efe8;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: center;
  padding: 10px 10px;
  white-space: nowrap;
  border: none;
}
.op-table thead th.is-left {
  text-align: left;
}
.op-table tbody td,
.op-table tbody th {
  padding: 9px 10px;
  border-bottom: 1px solid #f0ece3;
  vertical-align: middle;
  text-align: center;
  color: #4a453c;
  font-weight: 400;
}
.op-table tbody tr:last-child td {
  border-bottom: none;
}
.op-row:hover > td,
.op-row:hover > th {
  background: #fdfbf6;
}
.op-row.is-picked > td,
.op-row.is-picked > th {
  background: var(--rf-brand-tint);
}
.op-cell-num {
  width: 38px;
  color: #bdb6a7 !important;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
}
.op-cell-name {
  text-align: left !important;
  min-width: 170px;
}
.op-name {
  display: block;
  font-weight: 600;
  color: #191714;
}
.op-comment {
  display: block;
  font-size: 11px;
  color: #b0872f;
  margin-top: 1px;
}
.op-type {
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  color: #6f6a60;
}
.op-amount {
  font-weight: 700;
  color: #191714 !important;
  font-variant-numeric: tabular-nums;
}
.op-price {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.op-cell-content {
  text-align: left !important;
  min-width: 240px;
}
.op-flower {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 2px 4px 2px 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  font-size: 11px;
  color: var(--rf-brand-deep);
  white-space: nowrap;
}
.op-flower b {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.op-flower.is-unknown {
  background: #f4f1ea;
  border-color: #e7e3da;
  color: #8b8477;
}
.op-nocontent {
  font-size: 11px;
  color: #c4bdad;
}

/* funeral group header row */
.op-grouprow > td {
  background: #fbf8f0 !important;
  border-bottom: 1px solid var(--rf-brand-edge) !important;
  text-align: left !important;
  padding: 8px 10px !important;
}
.op-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.op-group-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--rf-brand);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}
.op-group-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--rf-brand-deep);
}
.op-group-meta {
  font-size: 11.5px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
}

/* assigned-to cell */
.op-assigned {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
}
.op-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-line);
  color: var(--rf-brand);
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.op-assigned-name {
  font-size: 11.5px;
  font-weight: 600;
  color: #191714;
}
.op-unassigned {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px dashed #e3b9b4;
  background: #f7ebe9;
  color: #a8483e;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.op-unassigned:hover {
  background: #f2ded9;
}
/* the pill is the second way into assign mode; while the "Assign tasks"
   button is hidden it is a plain status label, so it must not look clickable */
.op-unassigned.is-inert,
.op-unassigned.is-inert:hover {
  cursor: default;
  background: #f7ebe9;
}

/* progress columns */
.op-stamp {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: #6f6a60;
}
.op-stamp b {
  color: #191714;
  font-weight: 600;
}
.op-check {
  font-size: 11.5px;
  color: #4d7a52;
  font-weight: 600;
}
.op-check.is-empty {
  color: #d5cfc2;
  font-weight: 400;
}

/* selection checkbox */
.op-pick {
  width: 40px;
}
.op-box {
  width: 17px;
  height: 17px;
  border-radius: 5px;
  border: 1.5px solid #d8cfb8;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  vertical-align: middle;
}
.op-box.is-on {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
}
.op-box.is-some {
  background: var(--rf-brand-soft);
  border-color: var(--rf-brand-soft);
}
.op-pickall {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--rf-brand);
  cursor: pointer;
  white-space: nowrap;
}

/* ---------------- aside ---------------- */
.op-side {
  position: sticky;
  top: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}
.op-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.op-card-head {
  padding: 11px 16px;
  border-bottom: 1px solid #e7e3da;
  background: #fdfcfa;
  display: flex;
  align-items: center;
  gap: 8px;
}
.op-card-title {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.op-card-meta {
  margin-left: auto;
  font-size: 11.5px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
}
.op-subhead {
  padding: 8px 16px 4px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #a29b8d;
}
.op-tally {
  padding: 0 16px 10px;
  display: flex;
  flex-direction: column;
}
.op-tally-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid #f4f1ea;
  font-size: 12.5px;
}
.op-tally-row:last-child {
  border-bottom: none;
}
.op-tally-k {
  flex-grow: 1;
  min-width: 0;
  color: #4a453c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.op-tally-v {
  font-weight: 700;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.op-tally-bar {
  width: 54px;
  height: 4px;
  border-radius: 2px;
  background: #eae6dd;
  overflow: hidden;
  flex-shrink: 0;
}
.op-tally-bar span {
  display: block;
  height: 100%;
  background: var(--rf-brand-soft);
}

/* allocate panel */
.op-staff {
  max-height: 260px;
  overflow-y: auto;
  padding: 6px 10px;
}
.op-staff-row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
}
.op-staff-row:hover {
  background: #fdfbf6;
}
.op-staff-row.is-active {
  background: var(--rf-brand-tint);
  border-color: var(--rf-brand-line);
}
.op-staff-name {
  flex-grow: 1;
  min-width: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.op-staff-role {
  font-size: 11px;
  color: #a29b8d;
  white-space: nowrap;
}
.op-alloc-foot {
  padding: 10px 12px;
  border-top: 1px solid #e7e3da;
  background: #fdfcfa;
  display: flex;
  gap: 8px;
}
.op-alloc-foot .rf-btn {
  flex: 1 1;
  padding: 0 8px;
  font-size: 12px;
}
.op-btn-danger {
  border: 1px solid #e3b9b4;
  background: #fff;
  color: #a8483e;
}
.op-btn-danger:hover:not(:disabled) {
  background: #f7ebe9;
}
.rf-btn:disabled,
.op-btn-danger:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.op-alloc-note {
  padding: 9px 16px;
  font-size: 11.5px;
  color: #8b8477;
  background: #fbf8f0;
  border-bottom: 1px solid var(--rf-brand-edge);
}
.op-alloc-note b {
  color: var(--rf-brand-deep);
  font-weight: 700;
}

/* ---------------- flowers drawer ---------------- */
.op-drawer-wrap {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  justify-content: flex-end;
}
.op-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.18);
}
.op-drawer {
  position: relative;
  width: 420px;
  max-width: 100%;
  background: #fff;
  border-left: 1px solid #ddd7cb;
  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);
  display: flex;
  flex-direction: column;
}
.op-drawer-head {
  padding: 16px 20px;
  border-bottom: 1px solid #e2dcd0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
}
.op-drawer-title {
  font-size: 19px;
  font-weight: 600;
  color: #191714;
  margin: 0;
}
.op-drawer-sub {
  font-size: 12px;
  color: #8b8477;
  margin-top: 2px;
}
.op-close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}
.op-close:hover {
  background: #f6f4ef;
}
.op-warn {
  margin: 14px 20px 0;
  padding: 9px 12px;
  border-radius: 8px;
  background: #f9f1de;
  border: 1px solid #ecd9ad;
  font-size: 11.5px;
  color: var(--rf-brand-deep);
}
.op-drawer-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 14px 20px 22px;
}

@media (max-width: 1280px) {
  .op-body {
    grid-template-columns: minmax(0, 1fr);
  }
  .op-side {
    position: static;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .op-kpis {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 860px) {
  .op-kpis,
  .op-side {
    grid-template-columns: repeat(2, 1fr);
  }
  .op-bar,
  .op-kpis,
  .op-body {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* Export Excel sits beside the close button in the flower drawer header */
.op-export {
  margin-left: auto;
  height: 30px;
  padding: 0 11px;
  font-size: 12.5px;
  flex-shrink: 0;
}
.op-export + .op-close {
  margin-left: 0;
}

/* The range picker, sized up so the wrong day is hard to hit — the shared
   CalendarMonth stays compact on the other pages; only this popover grows. */
.op-cal {
  padding: 18px 20px;
  max-width: calc(100vw - 32px);
}
.op-cal-head {
  font-size: 15px;
  margin-bottom: 14px;
}
.op-cal-close {
  font-size: 22px;
}
.op-cal-months {
  gap: 28px;
}
.op-cal .rf-cal-month {
  flex: none;
  width: 322px;
}
.op-cal .rf-cal-month-head {
  font-size: 15px;
  margin-bottom: 10px;
}
.op-cal .rf-cal-nav {
  font-size: 15px;
  padding: 6px 10px;
  border-radius: 6px;
}
.op-cal .rf-cal-nav:hover {
  background: #f4f1ea;
}
.op-cal .rf-cal-grid {
  gap: 4px;
}
.op-cal .rf-cal-dow {
  height: 26px;
  font-size: 12px;
}
.op-cal .rf-cal-day {
  height: 40px;
  font-size: 15px;
  border-radius: 8px;
}
.op-cal-foot {
  margin-top: 16px;
  padding-top: 14px;
}
.op-cal-foot span {
  font-size: 14px;
  font-weight: 600;
  color: #4a453c;
}
/* Hanging off the range button, the two-month popover runs past the right
   edge on a tablet or small laptop — there it opens as a centred dialog
   instead, and the months share whatever width the window has. */
@media (max-width: 1100px) {
  .op-cal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(712px, calc(100vw - 32px));
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
  .op-cal .rf-cal-month {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }
}
/* two months side by side don't fit a phone — stack them */
@media (max-width: 600px) {
  .op-cal-months {
    flex-direction: column;
    gap: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ordered-products.css"],"names":[],"mappings":"AAAA;;;mDAGmD;;AAEnD;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;+EAC+E;AAC/E;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,gDAAgD;EAClD;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;;IAEE,qCAAqC;EACvC;EACA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;iEAEiE;AACjE;EACE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,qCAAqC;IACrC,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,SAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;AACA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":["/* Ordered products (redesign) — /ordered-products.\n   Depends on dashboard-redesign.css for the shell tokens and the shared\n   .rf-btn / .rf-segmented / .rf-num / .rf-spacer / .rf-empty. Every\n   legacy column is kept; only the styling moves. */\n\n.op-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------------- toolbar ---------------- */\n.op-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.op-presets {\n  display: flex;\n  gap: 2px;\n  background: #eae6dd;\n  padding: 3px;\n  border-radius: 9px;\n}\n.op-presets button {\n  border: none;\n  cursor: pointer;\n  padding: 6px 11px;\n  border-radius: 7px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: transparent;\n  color: #7c766a;\n  white-space: nowrap;\n}\n.op-presets button.is-active {\n  background: #fff;\n  color: #191714;\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);\n}\n\n/* range button + two-month popover (same shape as the overview picker) */\n.op-cal-wrap {\n  position: relative;\n}\n.op-range-btn {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.op-range-btn:hover,\n.op-range-btn.is-open {\n  border-color: #d8cfb8;\n}\n.op-range-days {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #8b8477;\n}\n.op-caret {\n  font-size: 10px;\n  color: #a29b8d;\n}\n.op-cal {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 60;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);\n  padding: 14px;\n}\n.op-cal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.op-cal-close {\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  color: #8b8477;\n}\n.op-cal-months {\n  display: flex;\n  gap: 18px;\n}\n.op-cal-foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f0ece3;\n}\n.op-cal-foot span {\n  flex-grow: 1;\n  font-size: 12px;\n  color: #8b8477;\n}\n\n.op-select {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 10px 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.op-select-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.op-select select {\n  border: none;\n  outline: none;\n  background: none;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  cursor: pointer;\n}\n\n.op-search {\n  height: 34px;\n  min-width: 190px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.op-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.op-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.op-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n\n.op-btn-on {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n.op-btn-on:hover {\n  background: var(--rf-brand-hover);\n}\n\n/* ---------------- KPI strip ---------------- */\n.op-kpis {\n  padding: 16px 28px 0;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 12px;\n  flex-shrink: 0;\n}\n.op-kpi {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  padding: 12px 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.op-kpi-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.op-kpi-v {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.op-kpi-v.is-warn {\n  color: #a8483e;\n}\n.op-kpi-v.is-ok {\n  color: #4d7a52;\n}\n.op-kpi-sub {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n\n/* ---------------- body: list + aside ---------------- */\n.op-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 16px 28px 28px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 300px;\n  gap: 18px;\n  align-items: start;\n}\n.op-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.op-section {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.op-section-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 18px;\n  border-bottom: 1px solid #e7e3da;\n  background: #fdfcfa;\n}\n.op-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n}\n.op-section.is-funeral .op-section-title::before,\n.op-section.is-retail .op-section-title::before {\n  content: \"\";\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-right: 8px;\n  vertical-align: 1px;\n}\n.op-section.is-funeral .op-section-title::before {\n  background: var(--rf-brand);\n}\n.op-section.is-retail .op-section-title::before {\n  background: var(--rf-accent);\n}\n.op-section-meta {\n  font-size: 12px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- table ---------------- */\n.op-scroll {\n  overflow-x: auto;\n}\n.op-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n.op-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #474339;\n  color: #f2efe8;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  text-align: center;\n  padding: 10px 10px;\n  white-space: nowrap;\n  border: none;\n}\n.op-table thead th.is-left {\n  text-align: left;\n}\n.op-table tbody td,\n.op-table tbody th {\n  padding: 9px 10px;\n  border-bottom: 1px solid #f0ece3;\n  vertical-align: middle;\n  text-align: center;\n  color: #4a453c;\n  font-weight: 400;\n}\n.op-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.op-row:hover > td,\n.op-row:hover > th {\n  background: #fdfbf6;\n}\n.op-row.is-picked > td,\n.op-row.is-picked > th {\n  background: var(--rf-brand-tint);\n}\n.op-cell-num {\n  width: 38px;\n  color: #bdb6a7 !important;\n  font-size: 11.5px;\n  font-variant-numeric: tabular-nums;\n}\n.op-cell-name {\n  text-align: left !important;\n  min-width: 170px;\n}\n.op-name {\n  display: block;\n  font-weight: 600;\n  color: #191714;\n}\n.op-comment {\n  display: block;\n  font-size: 11px;\n  color: #b0872f;\n  margin-top: 1px;\n}\n.op-type {\n  white-space: nowrap;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6f6a60;\n}\n.op-amount {\n  font-weight: 700;\n  color: #191714 !important;\n  font-variant-numeric: tabular-nums;\n}\n.op-price {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.op-cell-content {\n  text-align: left !important;\n  min-width: 240px;\n}\n.op-flower {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 2px 4px 2px 0;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  font-size: 11px;\n  color: var(--rf-brand-deep);\n  white-space: nowrap;\n}\n.op-flower b {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.op-flower.is-unknown {\n  background: #f4f1ea;\n  border-color: #e7e3da;\n  color: #8b8477;\n}\n.op-nocontent {\n  font-size: 11px;\n  color: #c4bdad;\n}\n\n/* funeral group header row */\n.op-grouprow > td {\n  background: #fbf8f0 !important;\n  border-bottom: 1px solid var(--rf-brand-edge) !important;\n  text-align: left !important;\n  padding: 8px 10px !important;\n}\n.op-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.op-group-num {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--rf-brand);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n.op-group-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--rf-brand-deep);\n}\n.op-group-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n}\n\n/* assigned-to cell */\n.op-assigned {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  white-space: nowrap;\n}\n.op-avatar {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-line);\n  color: var(--rf-brand);\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.op-assigned-name {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #191714;\n}\n.op-unassigned {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  border: 1px dashed #e3b9b4;\n  background: #f7ebe9;\n  color: #a8483e;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.op-unassigned:hover {\n  background: #f2ded9;\n}\n/* the pill is the second way into assign mode; while the \"Assign tasks\"\n   button is hidden it is a plain status label, so it must not look clickable */\n.op-unassigned.is-inert,\n.op-unassigned.is-inert:hover {\n  cursor: default;\n  background: #f7ebe9;\n}\n\n/* progress columns */\n.op-stamp {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  color: #6f6a60;\n}\n.op-stamp b {\n  color: #191714;\n  font-weight: 600;\n}\n.op-check {\n  font-size: 11.5px;\n  color: #4d7a52;\n  font-weight: 600;\n}\n.op-check.is-empty {\n  color: #d5cfc2;\n  font-weight: 400;\n}\n\n/* selection checkbox */\n.op-pick {\n  width: 40px;\n}\n.op-box {\n  width: 17px;\n  height: 17px;\n  border-radius: 5px;\n  border: 1.5px solid #d8cfb8;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.op-box.is-on {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n}\n.op-box.is-some {\n  background: var(--rf-brand-soft);\n  border-color: var(--rf-brand-soft);\n}\n.op-pickall {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--rf-brand);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* ---------------- aside ---------------- */\n.op-side {\n  position: sticky;\n  top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n.op-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.op-card-head {\n  padding: 11px 16px;\n  border-bottom: 1px solid #e7e3da;\n  background: #fdfcfa;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.op-card-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.op-card-meta {\n  margin-left: auto;\n  font-size: 11.5px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n}\n.op-subhead {\n  padding: 8px 16px 4px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.op-tally {\n  padding: 0 16px 10px;\n  display: flex;\n  flex-direction: column;\n}\n.op-tally-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  border-bottom: 1px solid #f4f1ea;\n  font-size: 12.5px;\n}\n.op-tally-row:last-child {\n  border-bottom: none;\n}\n.op-tally-k {\n  flex-grow: 1;\n  min-width: 0;\n  color: #4a453c;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.op-tally-v {\n  font-weight: 700;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.op-tally-bar {\n  width: 54px;\n  height: 4px;\n  border-radius: 2px;\n  background: #eae6dd;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.op-tally-bar span {\n  display: block;\n  height: 100%;\n  background: var(--rf-brand-soft);\n}\n\n/* allocate panel */\n.op-staff {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 6px 10px;\n}\n.op-staff-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 7px 8px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n}\n.op-staff-row:hover {\n  background: #fdfbf6;\n}\n.op-staff-row.is-active {\n  background: var(--rf-brand-tint);\n  border-color: var(--rf-brand-line);\n}\n.op-staff-name {\n  flex-grow: 1;\n  min-width: 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.op-staff-role {\n  font-size: 11px;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.op-alloc-foot {\n  padding: 10px 12px;\n  border-top: 1px solid #e7e3da;\n  background: #fdfcfa;\n  display: flex;\n  gap: 8px;\n}\n.op-alloc-foot .rf-btn {\n  flex: 1 1 0;\n  padding: 0 8px;\n  font-size: 12px;\n}\n.op-btn-danger {\n  border: 1px solid #e3b9b4;\n  background: #fff;\n  color: #a8483e;\n}\n.op-btn-danger:hover:not(:disabled) {\n  background: #f7ebe9;\n}\n.rf-btn:disabled,\n.op-btn-danger:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.op-alloc-note {\n  padding: 9px 16px;\n  font-size: 11.5px;\n  color: #8b8477;\n  background: #fbf8f0;\n  border-bottom: 1px solid var(--rf-brand-edge);\n}\n.op-alloc-note b {\n  color: var(--rf-brand-deep);\n  font-weight: 700;\n}\n\n/* ---------------- flowers drawer ---------------- */\n.op-drawer-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  display: flex;\n  justify-content: flex-end;\n}\n.op-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.18);\n}\n.op-drawer {\n  position: relative;\n  width: 420px;\n  max-width: 100%;\n  background: #fff;\n  border-left: 1px solid #ddd7cb;\n  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);\n  display: flex;\n  flex-direction: column;\n}\n.op-drawer-head {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2dcd0;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.op-drawer-title {\n  font-size: 19px;\n  font-weight: 600;\n  color: #191714;\n  margin: 0;\n}\n.op-drawer-sub {\n  font-size: 12px;\n  color: #8b8477;\n  margin-top: 2px;\n}\n.op-close {\n  margin-left: auto;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 17px;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.op-close:hover {\n  background: #f6f4ef;\n}\n.op-warn {\n  margin: 14px 20px 0;\n  padding: 9px 12px;\n  border-radius: 8px;\n  background: #f9f1de;\n  border: 1px solid #ecd9ad;\n  font-size: 11.5px;\n  color: var(--rf-brand-deep);\n}\n.op-drawer-body {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 14px 20px 22px;\n}\n\n@media (max-width: 1280px) {\n  .op-body {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .op-side {\n    position: static;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .op-kpis {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 860px) {\n  .op-kpis,\n  .op-side {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .op-bar,\n  .op-kpis,\n  .op-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* Export Excel sits beside the close button in the flower drawer header */\n.op-export {\n  margin-left: auto;\n  height: 30px;\n  padding: 0 11px;\n  font-size: 12.5px;\n  flex-shrink: 0;\n}\n.op-export + .op-close {\n  margin-left: 0;\n}\n\n/* The range picker, sized up so the wrong day is hard to hit — the shared\n   CalendarMonth stays compact on the other pages; only this popover grows. */\n.op-cal {\n  padding: 18px 20px;\n  max-width: calc(100vw - 32px);\n}\n.op-cal-head {\n  font-size: 15px;\n  margin-bottom: 14px;\n}\n.op-cal-close {\n  font-size: 22px;\n}\n.op-cal-months {\n  gap: 28px;\n}\n.op-cal .rf-cal-month {\n  flex: none;\n  width: 322px;\n}\n.op-cal .rf-cal-month-head {\n  font-size: 15px;\n  margin-bottom: 10px;\n}\n.op-cal .rf-cal-nav {\n  font-size: 15px;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n.op-cal .rf-cal-nav:hover {\n  background: #f4f1ea;\n}\n.op-cal .rf-cal-grid {\n  gap: 4px;\n}\n.op-cal .rf-cal-dow {\n  height: 26px;\n  font-size: 12px;\n}\n.op-cal .rf-cal-day {\n  height: 40px;\n  font-size: 15px;\n  border-radius: 8px;\n}\n.op-cal-foot {\n  margin-top: 16px;\n  padding-top: 14px;\n}\n.op-cal-foot span {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a453c;\n}\n/* Hanging off the range button, the two-month popover runs past the right\n   edge on a tablet or small laptop — there it opens as a centred dialog\n   instead, and the months share whatever width the window has. */\n@media (max-width: 1100px) {\n  .op-cal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: min(712px, calc(100vw - 32px));\n    max-height: calc(100vh - 32px);\n    overflow-y: auto;\n  }\n  .op-cal .rf-cal-month {\n    flex: 1 1 0;\n    width: auto;\n    min-width: 0;\n  }\n}\n/* two months side by side don't fit a phone — stack them */\n@media (max-width: 600px) {\n  .op-cal-months {\n    flex-direction: column;\n    gap: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
